const cfg = {
  url: window.raeEnv.oktaUri || 'https://investec.okta-emea.com',
  issuer: window.raeEnv.oktaIssuer || 'https://investec.okta-emea.com/oauth2/aus3ca0nu6r1Wppco0i7',
  clientId: window.raeEnv.oktaClientId || '0oa3c9ztog35m4Bwu0i7',
  redirectUri: window.raeEnv.oktaCallbackUrl || 'https://localhost:5003/implicit/callback',
  logoutUri: window.raeEnv.oktaLogoutUrl || 'https://localhost:5003/logout',
  timeoutUri: window.raeEnv.oktaTimeoutUrl || 'https://localhost:5003/timeout',
  loginUri: window.raeEnv.oktaLoginUrl || 'https://localhost:5003/login'
};

export const config = cfg;